import AdvancedSelectWithPath from '../advancedselectwithpath/AdvancedSelectWithPath.vue';

export default {
  name: 'D365AddressPicker',
  props: {
    value: {
      type: String,
      default: null
    },
    vzdcode: {
      type: String | Number,
      default: null
    },
    hasVzdCode: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    controlClass: {
      type: String,
      default: ''
    },
    colControlClass: {
      type: String,
      default: ''
    },
    labelAddress: {
      type: String,
      default: 'general.customAddress'
    },
    checkboxClass: {
      type: String,
      default: ''
    },
    labelControlClass: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    withApartments: {
      type: Number,
      default: 0
    },
    isFreeTextAddressAllowed: {
      type: Boolean,
      default: true
    },
    customPath: {
      type: String,
      default: null
    }
  },

  components: {
    AdvancedSelectWithPath
  },

  data () {
    return {
      content: {
        text: this.value,
        manualEntry: this.isFreeTextAddressAllowed && !this.hasVzdCode,
        id: this.vzdcode,
        house_id: null
      },
      selectedItem: null
    }
  },

  computed: {
    routepath () {
      if (this.customPath) {
        return this.customPath;
      }

      let path = '';
      const d365url = this.$store.getters.getD365SupportUrl();
      if (d365url) {
        path = `address/list/${this.withApartments}?simple=1`;
        path = `${d365url}/api/${path}`;
      }
      return path;
    }
  },
  methods: {
    changeMode (mode) {
      this.content.manualEntry = mode;
      if (mode) {
        this.content.id = null;
      }
      this.selectedItem = null;
      this.updateValue();
    },

    optionChanged (el, item) {
      if (item) {
        this.content.text = item.addrtext;
        this.content.id = item.id;
        this.content.house_id = item.house_id;
      } else {
        this.content.text = '';
        this.content.id = null;
        this.content.house_id = null;
      }
      this.selectedItem = item;
      this.updateValue();
    },

    updateValue () {
      this.$emit('changed', this.content, this.selectedItem);
    }
  },

  mounted () {
  },

  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.content.text = val;
      }
    },
    hasVzdCode: {
      immediate: true,
      handler (val) {
        if (!this.isFreeTextAddressAllowed) {
          return;
        }
        this.content.manualEntry = !val;
      }
    },
    vzdcode: {
      immediate: true,
      handler (val) {
        this.content.id = val;
      }
    }
  }
}
